export default "__VITE_ASSET__Pz555x0x__"